import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from '../dcpcApi';
import { H_MODELS, H_MODELS_CAN_DELETE_AND_LOGS } from './tags';

dcpcApi.enhanceEndpoints({ addTagTypes: [H_MODELS, H_MODELS_CAN_DELETE_AND_LOGS] });

const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getHModels: builder.query({
      query: () => 'v2/h-models',
      providesTags: [H_MODELS],
    }),
    createOrUpdateHModels: builder.mutation({
      query: ({ body }) => ({
        url: 'v2/h-models',
        method: 'POST',
        body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: [H_MODELS],
    }),
    getHModel: builder.query({
      query: (id) => `v2/h-models/${id}`,
      providesTags: (result, error, arg) => [{ type: H_MODELS, id: arg }],
    }),
    getHModelsCanDeleteAndLogs: builder.query({
      query: () => 'v2/h-models/can-delete-and-logs',
      providesTags: [H_MODELS_CAN_DELETE_AND_LOGS],
    }),
  }),
});

export const {
  useGetHModelQuery, // не используется
  useGetHModelsQuery,
  useCreateOrUpdateHModelsMutation,
  useGetHModelsCanDeleteAndLogsQuery,
} = api;

const hModelsSelect = (state) => api.endpoints.getHModels.select()(state);
const hModelsSelector = (state) => hModelsSelect(state).data || [];

export const filterhModelsSelector = createSelector(
  hModelsSelector,
  (_, searchText) => searchText,
  (hModels, searchText) => ({
    columns: [
      {
        label: 'Код',
      },
      {
        label: 'Название объекта',
      },
      {
        label: 'Логирование',
      },
      {
        label: 'Время жизни логов в дн',
      },
      {
        label: 'Автоудаление',
      },
      {
        label: 'Время жизни объекта в дн',
      },
    ],
    rows: hModels
      .reduce((acc, cur) => {
        const { object, name, activeLogging, lifecycleLogInDays, activeAutoDelete, lifecycleObjectInDays } = cur;
        const row = [object, name, activeLogging.toString(), lifecycleLogInDays, activeAutoDelete.toString(), lifecycleObjectInDays];
        if (row.filter((v) => v !== null && v.toString().toUpperCase().includes(searchText.toUpperCase())).length > 0) {
          acc.push(row);
        }
        return acc;
      }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (object) => `${object}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать объект',
    },
  }),
);

export const hModelsBySearchTextSelector = (searchText) => (state) => filterhModelsSelector(state, searchText);
